import { getHasPremiumArticleEloquaForm } from '@/store/articles';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import React from 'react';
import { useSelector } from 'react-redux';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import EEPlaceholder from 'components/Sections/EEPlaceholder';

const ArticleBottomContainer: React.FC<ComponentProps> = ({ rendering }) => {
  const havePremiumArticleEloquaForm = useSelector(getHasPremiumArticleEloquaForm);
  const { sitecoreContext } = useSitecoreContext();

  if (sitecoreContext.pageEditing) {
    return <EEPlaceholder>Article Bottom Container</EEPlaceholder>;
  }

  if (havePremiumArticleEloquaForm) return null;

  return <Placeholder name="abrdn-article-bottom-content" rendering={rendering} />;
};

export default ArticleBottomContainer;
